import { css } from '@inter-ikea-kompis/web-component';
import MiniSurveyAnimationNameEnum from '../../enums/MiniSurveyAnimationNameEnum.js';
export default class MiniSurveyStyle {
    /**
     * Returns styles.
     *
     * @param options ...
     * @param options.theme ...
     * @param options.visible ...
     * @param options.zIndex ...
     * @param options.state ...
     * @param options.isSmallDevice ...
     * @param options.top ...
     * @param options.left ...
     * @param options.right ...
     * @returns Styles.
     */
    static getStyle(options) {
        const { color, motion, spacing, border, elevation } = options.theme;
        const top = options.top !== null ? `${options.top / 16}rem` : 'auto';
        const left = options.left !== null ? `${options.left / 16}rem` : 'auto';
        const right = options.right !== null ? `${options.right / 16}rem` : 'auto';
        return css `
			:host {
				position: absolute;
				top: ${!options.isSmallDevice ? top : 0};
				left: ${!options.isSmallDevice ? left : 0};
				right: ${!options.isSmallDevice ? right : 0};
				max-width: ${400 / 16}rem;
				width: 100%;
				z-index: ${options.zIndex};
				display: ${options.visible ? 'block' : 'none'};
			}

			.container {
				padding: ${spacing.space100 / 16}rem;
			}

			kompis-mini-survey-card {
				overflow: hidden;
				border-radius: ${border.radius.radius4 / 16}rem;
				color: ${color.neutral.grey900};
				background-color: ${color.neutral.white};
				border-width: 0;
				box-shadow: 0 ${spacing.space25 / 16}rem ${spacing.space100 / 16}rem
					${elevation.color.default};
				padding: ${spacing.space150 / 16}rem;

				animation-name: ${options.visible
            ? MiniSurveyAnimationNameEnum.opening
            : MiniSurveyAnimationNameEnum.closing};
				animation-duration: ${options.visible ? motion.duration.medium : motion.duration.small};
				animation-fill-mode: both;
				animation-timing-function: ${options.visible ? motion.ease.enter : motion.ease.exit};
			}

			@keyframes ${MiniSurveyAnimationNameEnum.opening} {
				from {
					transform: translateX(0);
				}
				to {
					transform: translateX(10);
				}
			}
			@keyframes ${MiniSurveyAnimationNameEnum.closing} {
				from {
					transform: translateX(10);
				}
				to {
					transform: translateX(0);
				}
			}
		`;
    }
}
//# sourceMappingURL=MiniSurveyStyle.js.map